const OriginalSheetTable = ({ data }) => (
  <div className="overflow-x-auto overflow-y-auto max-h-[60vh]">
    <table className="min-w-full table-auto border">
      <tbody>
        {data.map((row, i) => (
          <tr key={i} className="border">
            <td className="border p-2 font-bold">{i + 1}</td>
            {row.map((cell, j) => (
              <td key={j} className="border p-2">{cell || ''}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
export default OriginalSheetTable;
